<div
  *ngIf="url"
  class="w-100 d-flex flex-column justify-content-center align-items-center"
  style="margin-top: 30px;"
>
  <div>
    <img *ngIf="config?.image" src="{{config?.image}}">
  </div>
  <div
    style="width: 40%; display: flex; justify-content: center; align-items: center; margin-bottom: 16px;"
  >
    <span
      *ngIf="config?.message"
      style="font-size: 12px; text-align: center;"
    >
      {{config?.message}}
    </span>
  </div>
  <div
    *ngIf="config?.button"
    style="display: flex; justify-content: center; align-items: center;"
  >
    <a
      style="text-decoration: none; height: 28px; width: 110px; display: flex; align-items: center; justify-content: center; font-size: 12px; color: white; background-color: #87aacb; border-radius: 5px;"
      href="{{url}}"
      target="{{config?.target || '_blank'}}"
      rel="noopener"
    >
      <span *ngIf="config?.icon" class="material-symbols-outlined text-sub-title me-2">{{config?.icon}}</span>
      {{config?.button}}
    </a>
  </div>
  <div
    *ngIf="!config?.button"
    style="display: flex; justify-content: center; align-items: center;"
  >
    <a
      href="{{url}}"
      target="{{config?.target || '_blank'}}"
      rel="noopener"
    >
      {{url}}
    </a>
  </div>
</div>
